import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b98da1a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98da1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b98da1a')) {
      api.createRecord('0b98da1a', component.options)
    } else {
      api.reload('0b98da1a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b98da1a&scoped=true", function () {
      api.rerender('0b98da1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/citySelect/index.vue"
export default component.exports